module.exports = __webpack_public_path__ + "img/ic_video.6f330ba5.png";